export default __webpack_public_path__ + "static/media/image6.c502954b.jpg";